<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <form v-on:keypress.enter.prevent="searchSheetReport" class="my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสชีท"
                        v-model="search.code"
                        aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <multiselect
                        class="form-control select mr-sm-2"
                        v-model="search.machine"
                        :options="optionMachine"
                        label="name"
                        placeholder="เครื่องผลิตชีท"
                        track-by="name">
                    </multiselect>
                    &nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchSheetReport">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <template
                        v-if="canInventoryReportsSheetsOrder || user.username == '20502' || user.username == '20534'">
                        <router-link to="sheet-report-information">
                            <button
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                                <icon name="plus"></icon>
                                ผลิตชีท
                            </button>
                        </router-link>
                        &nbsp
                    </template>
                </form>
                <button v-if="sheet_report.length > 0"
                        v-on:click="showModalPrint"
                        class="btn btn-primary my-2 my-sm-0">
                    <icon name="file-download"></icon>
                    พิมพ์รายงาน
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">เครื่อง</th>
                    <th scope="col">เวลา<br>เริ่มผลิต</th>
                    <th scope="col">รหัสชีท</th>
                    <th scope="col">ชีท</th>
                    <th scope="col">จำนวน</th>
                    <th scope="col">วันที่เริ่มผลิต</th>
                    <th scope="col">ช่วง</th>
                    <th scope="col">กลุ่ม</th>
                    <th scope="col">รายละเอียดชีท</th>
                    <th scope="col">สูตรเม็ด</th>
                    <!--<th scope="col">วันที่สิ้นสุดการผลิต</th>-->
                    <!--<th scope="col">เวลาที่สิ้นสุดการผลิต</th>-->
                    <!--<th scope="col">กะ</th>-->
                    <th scope="col">วันที่อัพเดต</th>
                    <th scope="col">สถานะต่อเนื่อง</th>
                    <th scope="col">ผู้สั่งผลิต</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">ปัญหาการผลิต</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,i) in sheet_report">
                    <td>
                        <template v-if="data.machine && i != 0">
                            <template v-if="sheet_report[i-1].machine.name != data.machine.name">
                                {{ data.machine.name }}
                            </template>
                        </template>
                        <template v-else-if="data.machine && i == 0">
                            {{ data.machine.name }}
                        </template>
                        <template v-else>
                            <p>ไม่ระบุ</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.start_time">
                            {{ data.start_time }}
                        </template>
                        <template v-else>ไม่ระบุ</template>
                    </td>
                    <td>
                        <template v-if="data.sheet">
                            {{ data.sheet.code }}
                        </template>
                        <template v-else>
                            <p>ไม่ระบุ</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.sheet">
                            {{ data.sheet.name }}
                        </template>
                        <template v-else>
                            <p>ไม่ระบุ</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.quantity">
                            {{ data.quantity | amount }}
                        </template>
                        <template v-else>ไม่ระบุ</template>
                    </td>

                    <td>
                        <template v-if="data.start_date">
                            {{ data.start_date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>ไม่ระบุ</template>
                    </td>
                    <td>
                        <template v-if="data.shift_start">
                            {{ data.shift_start.name }}
                        </template>
                        <template v-else>
                            <p>ไม่ระบุ</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.group_id">
                            {{ data.group_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sheet">
                            <div class="text-left">
                                กว้าง :{{ data.sheet.width ? data.sheet.width : "-" }} ยาว
                                :{{ data.sheet.length ? data.sheet.length : "-" }}
                            </div>
                            <div class="text-left">
                                ความหนา : {{ data.sheet.thickness ? data.sheet.thickness : "-" }}
                            </div>
                            <div class="text-left">
                                น้ำหนัก :{{ data.sheet.weight ? data.sheet.weight : "-" }}
                            </div>
                            <div class="text-left">
                                เส้นผ่านศูนย์กลาง : {{ data.sheet.diameter ? data.sheet.diameter : "-" }}
                            </div>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.grain">
                            เม็ดโฟม : {{ data.grain.code }}<br/>
                            เก่า : {{ data.grain_old }} ใหม่ : {{ data.grain_new }}<br/>
                            แป้ง : {{ data.flour }}<br/>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <!--<td>-->
                    <!--<template v-if="data.end_date">-->
                    <!--{{ data.end_date }}-->
                    <!--</template>-->
                    <!--<template v-else>-->
                    <!--<p>ไม่ระบุ</p>-->
                    <!--</template>-->
                    <!--</td>-->
                    <!--<td>-->
                    <!--<template v-if="data.end_time">-->
                    <!--{{ data.end_time }}-->
                    <!--</template>-->
                    <!--<template v-else>-->
                    <!--<p>ไม่ระบุ</p>-->
                    <!--</template>-->
                    <!--</td>-->
                    <!--<td>-->
                    <!--<template v-if="data.shift_end">-->
                    <!--{{ data.shift_end.name }}-->
                    <!--</template>-->
                    <!--<template v-else>-->
                    <!--<p>ไม่ระบุ</p>-->
                    <!--</template>-->
                    <!--</td>-->
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                    <td>
                        <template v-if="data.work_start == 3">
                            <img src="@/assets/check.png" width="20px"/>
                        </template>
                        <template v-else>
                            <img src="@/assets/not.png" width="15px"/>
                        </template>
                    </td>
                    <td>{{ data.user }}</td>
                    <!--                    <td>{{data.reason}}</td>-->
                    <td>
                        <template v-if="data.reason">
                            {{ data.reason }}<br/>
                            <a @click="showModalReason(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </template>
                        <template v-else>
                            <b-button
                                class="btn btn-success"
                                @click="showModalReason(data.id)">
                                <icon name="plus"></icon>
                            </b-button>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.problem">
                            {{ data.problem }}<br/>
                            <a @click="showModalProblem(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </template>
                        <template v-else>
                            <b-button
                                class="btn btn-success"
                                @click="showModalProblem(data.id)">
                                <icon name="plus"></icon>
                            </b-button>
                        </template>
                    </td>
                    <td>
                        <a @click="showReportSheet(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <!--        <div v-if="sheet_report.length > 0">-->
        <!--            <vue-pagination :pagination="dataPaginate"-->
        <!--                            @paginate="getSheetReportPage">-->
        <!--            </vue-pagination>-->
        <!--        </div>-->
        <br/>
        <!----------print report--------->
        <b-modal hide-header hide-footer ref="report_print">
            <div>
                <br>
                <h4 class="text-center">กรุณาเลือกกะ/วันที่ ที่ต้องการพิมพ์รายงาน</h4>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">กรุณาเลือกวันที่</b-col>
                    <b-col class="col-sm-6">
                        <date-picker
                            v-model="report.date"
                            type="date"
                            class="w-100"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่">
                        </date-picker>
                    </b-col>
                </div>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">กรุณาเลือกกะ</b-col>
                    <b-col class="col-sm-6">
                        <b-form-select
                            v-model="report.shift"
                            class="w-100"
                            :options="optionShip">
                        </b-form-select>
                    </b-col>
                </div>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button type="button"
                                @click="print(report)"
                                class="btn btn-primary">
                            <icon name="file-download" style="width: 25px"></icon>
                            พิมพ์
                        </button>
                        &nbsp&nbsp
                        <button type="button" class="btn btn-success" @click="hideModalPrint">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="report_problem">
            <div style="padding: 0px 20px;text-align: center">
                <br>
                <h4 class="text-center">รายงานปัญหาการผลิต</h4>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <textarea
                            v-model="form.problem"
                            rows="5"
                            class="form-control"
                        ></textarea>
                    </div>
                </div>

                <br/>
                <button @click="saveProblemSheetReport"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalProblem">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
                <!--                                <pre class="alert-primary">{{form}}</pre>-->
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="report_reason">
            <div style="padding: 0px 20px;text-align: center">
                <br>
                <h4 class="text-center">หมายเหตุ</h4>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <textarea
                            v-model="form.reason"
                            rows="5"
                            class="form-control"
                        ></textarea>
                    </div>
                </div>

                <br/>
                <button @click="saveReasonSheetReport"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalReason">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
                <!--                                <pre class="alert-primary">{{form}}</pre>-->
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ sheet_report }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import format from 'date-fns/format'
import DatePicker from 'vue2-datepicker'
import PrintSheetReportModal from "./PrintSheetReportModal";
import moment from "moment";

import {canInventoryReportsSheetsOrder, canInventoryReportsSheetsUpdate} from "../../../util/Permissions"

export default {
    name: "sheet-report",
    components: {
        PrintSheetReportModal,
        VuePagination,
        DatePicker,
        Multiselect
    },
    data() {
        return {
            id: "",
            activeCloseDate: false,
            dateOne: '',
            search: {
                code: "",
                date: "",
                machine: ""
            },
            report: {
                shift: "",
                date: ""
            },
            optionShip: [
                {value: "", text: "กรุณาเลือกกะ"},
                {value: 1, text: "กลางวัน"},
                {value: 2, text: "กลางคืน"}
            ],
            domain: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        this.domain = domain + '/sheet-report-pdf';
        this.$store.dispatch("ReportSheet/get");
        this.$store.dispatch("Sheet/getAll");
        this.$store.dispatch('Machine/getMachineSheet');
    },
    computed: {
        canInventoryReportsSheetsOrder,
        canInventoryReportsSheetsUpdate,
        ...mapState({
            sheet_report: state => {
                return state.ReportSheet.table;
            },
            optionSheet: state => {
                return state.Sheet.sheet_all;
            },
            optionMachine: state => {
                return state.Machine.machine_sheet;
            },
            dataPaginate: state => {
                return state.ReportSheet.dataPaginate;
            },
            form: state => {
                return state.ReportSheet.Form;
            },
            user: state => {
                return state.Auth.user;
            },
        }),

    },
    methods: {
        formatDates(dateOne) {
            this.search.date = dateOne;
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            return formattedDates
        },
        showReportSheet(id) {
            this.$store.dispatch("ReportSheet/show", id).then(() => {
                this.$router.push({
                    name: "sheet-report-information",
                    params: {id}
                });
            });
        },
        searchSheetReport() {
            this.event_submit = true;
            let machine_id = "";
            if (this.search.machine) {
                machine_id = this.search.machine.id
            } else {
                machine_id = ""
            }
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.$store.dispatch("ReportSheet/search", {
                code: this.search.code,
                date: this.search.date,
                machine: machine_id
            });
        },
        showModalPrint() {
            this.$refs.report_print.show();
        },
        hideModalPrint() {
            this.$refs.report_print.hide();
        },
        getSheetReportPage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                let machine_id = "";
                if (this.search.machine) {
                    machine_id = this.search.machine.id
                } else {
                    machine_id = ""
                }
                this.$store.dispatch("ReportSheet/search", {
                    page: page,
                    code: this.search.code,
                    date: this.search.date,
                    machine: machine_id
                });
            } else {
                this.$store.dispatch('ReportSheet/get', page);
            }
        },
        clearDate() {
            this.search.date = "";
        },
        print: function (report) {
            if (!report.date) {
                alert("กรุณาเลือกวันที่")
            } else {
                let shift = report.shift ? report.shift : 'null';
                const date = moment(report.date).format("YYYY-MM-DD");
                window.open(this.domain + "/" + shift + "/" + date);
                this.hideModalPrint();
                this.report.shift = "";
                this.report.date = "";
            }
        },
        showModalProblem(id) {
            this.$store.dispatch("ReportSheet/showReason", id).then(() => {
                this.$refs.report_problem.show();
            });
        },
        hideModalProblem() {
            this.$refs.report_problem.hide();
        },
        showModalReason(id) {
            this.$store.dispatch("ReportSheet/showReason", id).then(() => {
                this.$refs.report_reason.show();
            });
        },
        hideModalReason() {
            this.$refs.report_reason.hide();
        },
        saveProblemSheetReport() {
            this.$store.dispatch("ReportSheet/save", this.form.id).then(data => {
                if (!data) {
                    alert("กรุณาใส่ปํญหาการผลิตไม่เกิน 255 ตัวอักษร")
                } else {
                    this.hideModalProblem();
                    this.$store.dispatch("ReportSheet/get");
                }
            });
        },
        saveReasonSheetReport() {
            this.$store.dispatch("ReportSheet/save", this.form.id).then(() => {
                this.hideModalReason();
                this.$store.dispatch("ReportSheet/get");
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.select {
    border: 0;
}

.border-left-0 {
    border-left: 0;
}
</style>
